class AccessTokenStorage {
  token: string | undefined;

  constructor(token?: string) {
    this.token = token;
  }

  setToken = (token: string) => {
    this.token = token;
  };

  getToken = () => {
    return this.token;
  };
}

export default new AccessTokenStorage();
